import React from 'react';
import { useSelector } from 'react-redux';
import * as amplitude from "@amplitude/analytics-browser";


const marketOptions = {
	SHOP_BY_VENDOR: 1,
	SHOP_BY_LEAD_TYPE: 2,
	BROWSE_ALL_LEADS: 3,
}

function MarketSection({ title, leadPreview, workflowPreview,handleNavigation}) {
	const agentInfo = useSelector((state) => state.agent.userData);
	/**
	 * @param {PointerEvent} evt
	 * @param {number} marketOption
	 */
	const marketOptionClicked = (evt, marketOption) => {
		evt.stopPropagation();
		let eventName = "";
		let linkText = "";
		switch (marketOption) {
			case marketOptions.SHOP_BY_VENDOR: {
				eventName = "Shop by Vendor";
				linkText = "Shop by Vendor";
				break;
			}
			case marketOptions.SHOP_BY_LEAD_TYPE: {
				eventName = "Shop by Lead Type";
				linkText = "Shop by Lead Type";
				break;
			}
			case marketOptions.BROWSE_ALL_LEADS: {
				eventName = "Browse All Leads";
				linkText = "Browse All Leads";
				break;
			}
			default: {
				console.error("marketOptionClicked: Unknown market option: %s", marketOption);
				break;
			}
		}
		try {
			amplitude.track(
				eventName,
				{
					"Link Text": linkText,
					trigger_source: "Funnel Market Dash",
					Agent_code: agentInfo.agentCode,
				}
			);
		} catch (err) {
			console.error(
				"marketOptionClicked: Exception occurred during Amplitude communication attempt: %s",
				err,
				err,
			);
		}
		handleNavigation(title,'faIdCard');
    }

	/**
	 * @param {PointerEvent} evt
	 * @param {string} text
	 */
	const leadTypeOptionClicked = (evt, text) => {
		evt.stopPropagation();
		try {
			amplitude.track(
				"Shop Specific Lead Type",
				{
					"Link Text": text,
					trigger_source: "Funnel Market Dash",
					Agent_code: agentInfo.agentCode,
				}
			);
		} catch (err) {
			console.error(
				"marketOptionClicked: Exception occurred during Amplitude communication attempt: %s",
				err,
				err,
			);
		}
		handleNavigation(title,'faIdCard');
	}

    return (
        <div className={`quilityParentBlockWrapper twoX selectable`}  onClick={()=> handleNavigation(title,'faIdCard')}>
            <div className="quilityParentBlockHeader">
                <div className="quilityParentBlockTitle">{title}</div>
            </div>
            
            <div className="quilityParentBlockContent">
                {title==='Leads' ? (
                    <div className={`quilityNestedBlockWrapper `} key={'index'} style={{marginTop: '25px'}}>
                        <div className="quilityParentBlockHeader">
                            <div className="quilityParentBlockTitle">Shop For Leads</div>
                        </div>
                        <div className="quilityNestedBlockContent">
                            <div className="quilityDataLine" onClick={evt => marketOptionClicked(evt, marketOptions.SHOP_BY_VENDOR)}>
                                <span className="quilityDataLineTitle" style={{display: 'inline-block',width: '200px'}}>Shop By Vendor</span>
                            </div>
                            <div className="quilityDataLine" onClick={evt => marketOptionClicked(evt, marketOptions.SHOP_BY_LEAD_TYPE)}>
                                <span className="quilityDataLineTitle" style={{display: 'inline-block',width: '200px'}}>Shop By Lead Type</span>
                            </div>
                            {leadPreview.map((item, index) =>(
                                <div className="quilityDataLine" key={`leadPreview${index}`} onClick={evt => leadTypeOptionClicked(evt, item.type)}>
                                    <span className="quilityDataLineTitle extraIndent" style={{display: 'inline-block',width: '200px'}}>{item.type}</span>
                                </div>
                            ))}
                            <div className="quilityDataLine" onClick={evt => marketOptionClicked(evt, marketOptions.BROWSE_ALL_LEADS)}>
                                <span className="quilityDataLineTitle" style={{display: 'inline-block',width: '200px'}}>Browse All Leads</span>
                            </div>
                            </div>
                            
                    </div>
                    
                ) : (
                    <>
                    {workflowPreview ?(
                       
                        <div className={`quilityNestedBlockWrapper`} key={'index'} style={{marginTop: '25px'}}>
                            <div className="quilityParentBlockHeader">
                                <div className="quilityParentBlockTitle">Shop For Leads</div>
                            </div>
                            <div className="quilityNestedBlockContent">
                                {workflowPreview.map((item, index) =>(
                                    <div className="quilityDataLine" key={`workflowPreview${index}`}>
                                        <span className="quilityDataLineTitle" style={{display: 'inline-block',width: '200px'}}>{item.type}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        null
                    )}
                    </>
                )}
                
                
            </div>
            <div className="clearFooter">
                
            </div>
        </div>
    );
}

export default MarketSection;